// SPDX-License-Identifier: AGPL-3.0-or-later

import {GifVideoPoolProvider} from '@app/features/channel/components/GifVideoPool';
import {GifPickerView} from '@app/features/channel/components/pickers/gif/GifPickerView';

export interface GifPickerProps {
	onClose?: () => void;
}

export const GifPicker = ({onClose}: GifPickerProps = {}) => (
	<GifVideoPoolProvider data-flx="channel.pickers.gif.gif-picker.gif-video-pool-provider">
		<GifPickerView onClose={onClose} data-flx="channel.pickers.gif.gif-picker.gif-picker-view" />
	</GifVideoPoolProvider>
);
